var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-popover",
    {
      attrs: {
        trigger: ["click"],
        placement: "bottomLeft",
        overlayClassName: "popover-channel zero-padding",
      },
      scopedSlots: _vm._u([
        {
          key: "content",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "channels" },
                _vm._l(
                  _vm.filteredMessengerChannels,
                  function (channel, index) {
                    return _vm.filteredMessengerChannels.length > 0
                      ? _c("ChannelStatusItem", {
                          key: channel._id,
                          attrs: { channel: channel, "whatsapp-modal": false },
                        })
                      : _vm._e()
                  }
                ),
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "actionButtonBreadcrumb m-0 wp-btn",
          class: ((_obj = {}), (_obj[_vm.getHealthStatus()] = true), _obj),
          staticStyle: { "min-width": "20px", "max-width": "25px" },
        },
        [
          _c("MessengerIcon", {
            staticClass: "whatsapp-channel-icon",
            attrs: { specialBackgroundMode: "" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }